import React, { useState, useEffect, useRef } from 'react'
import classes from './dropdown.module.css'
import classNames from 'classnames'
import { ReactComponent as DownIcon } from '../../../assets/images/down.svg'
import { useHideOnClickOutside } from '../../../hooks/useHideOnClickOutside'

export const Dropdown = ({ options, initialValue = 'Select', onChange }) => {
    const [current, changeCurrent] = useState(initialValue)
    const [active, toggleActive] = useState(false)

    // If initialValue changes, override current state
    useEffect(() => {
        changeCurrent(initialValue)
    }, [initialValue])

    const optionsRef = useRef()

    useHideOnClickOutside({
        open: active,
        hide: _ => toggleActive(false),
        el: optionsRef.current,
    })

    return (
        <div className={classes.dropdown}>
            <button
                className={classes.dropdownCurrentDisplay}
                onClick={() => toggleActive(!active)}
            >
                <span className={classes.dropdownCurrent}>{current}</span>
                <DownIcon className={classes.dropdownCurrentDisplayImage} />
            </button>
            <div
                className={classNames(
                    classes.dropdownOptions,
                    active && classes.dropdownOptionsActive
                )}
                ref={optionsRef}
            >
                {options.map(option => (
                    <button
                        className={classes.dropdownOption}
                        key={option.toString()}
                        onClick={() => {
                            changeCurrent(option)
                            onChange(option)
                            toggleActive(false)
                        }}
                    >
                        {option}
                    </button>
                ))}
            </div>
        </div>
    )
}
